var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "b-button-group",
        {
          class: "us_overlay us_zoomControl lbs-scope-container",
          attrs: { vertical: "", size: "sm" }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "zoom-button",
              class: { "is-selected": _vm.selectedMag === "fit" },
              attrs: {
                size: "sm",
                title: _vm.$t("uScope.extensions.zoom.fit")
              },
              on: { click: _vm.zoomFit }
            },
            [_c("icon", { attrs: { name: "compress" } })],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.mags, function(mag) {
            return _c("zoom-button", {
              key: mag,
              attrs: {
                mag: mag,
                "base-mag": _vm.baseMag,
                "is-selected": mag === _vm.selectedMag,
                "is-pyramid-level": !!_vm.pyramid.find(function(p) {
                  return p.realMag === mag
                })
              },
              on: {
                click: function($event) {
                  return _vm.changeZoom(mag)
                }
              }
            })
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/zoom/ZoomButtonList.vue?vue&type=template&id=5695969a&scoped=true&
// module id = 521
// module chunks = 0